import { useQuery } from "@apollo/client";
import { Card, Row, Col, Button } from "reactstrap";
import { GET_ORG_COMPARISON_DATA } from "../../../../queries";

import { useHistory } from "react-router-dom";

import EvaluationRadar from "../Component/EvaluationRadar";
import animetionLogo from "../../../../assets/utils/images/animetion_logo.gif";
import { light } from "@mui/material/styles/createPalette";

/**
 * 比較分析Page/組織診断結果Section
 * @param {*} param0
 * @returns
 */

const EvaluationData = ({ orgIdArray, orgPk, avePk, target }) => {
  const history = useHistory();

  const { loading, error, data } = useQuery(GET_ORG_COMPARISON_DATA, {
    variables: { orgPks: orgIdArray, orgPk: orgIdArray },
  });

  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) {
    window.location.href = "/#/dashboards/journy";
  }
  if (!data) return "...Not Found";

  return (
    <div>
      <div className="comp_area">
        {/* <Button
          className="mb-2 mr-2 pt-2 pb-2 pr-5 pl-5 main_button comp_btn"
          onClick={(e) => {
            alert("順次更新し当該機能を追加してきます");
          }}
        >
          業界平均
        </Button>
        <Button
          className="mb-2 mr-2 pt-2 pb-2 pr-5 pl-5 main_button comp_btn"
          onClick={(e) => {
            alert("順次更新し当該機能を追加してきます");
          }}
        >
          組織規模
        </Button> */}
      </div>
      <Card className="mb-5  org_contentarea">
        <div className="org_subtitle_sec">
          <h4 className="org_subtitle">
            組織診断結果
            <spna
              className="ml-3"
              style={{ fontSize: "13px", fontWeight: 400, color: "#808080" }}
            >
              *業界平均と組織規模のみ比較でき、特定の組織の診断結果は比較はできません。
            </spna>
          </h4>
        </div>
        <div className="org_item comparion_item">
          <div>
            <Row>
              <Col md="6" lg="8">
                <EvaluationRadar
                  diagnoseData={data}
                  orgIdArray={orgIdArray}
                  orgPk={orgPk}
                  avePk={avePk}
                  target={target}
                />
              </Col>
              <Col
                md="6"
                lg="4"
                style={{ position: "relative", textAlign: "center" }}
              >
                <Button
                  onClick={() => history.push("evaluation")}
                  className="mr-2 pt-2 pb-2 pr-5 pl-5 main_button comparison_btn"
                >
                  組織診断を実施
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default EvaluationData;
